import { request } from '../utils/request';

const CLOCK_SUPPORT_CATEGORY = 'clock-support';

/**
 * List user feedback for the Clock product page.
 * @param {number} [limit=50]
 * @returns {Promise<Array<{ uuid, category, subject, message, createTime }>>}
 */
export async function fetchClockSupportSubmissions(limit = 50) {
  const params = new URLSearchParams({
    category: CLOCK_SUPPORT_CATEGORY,
    limit: String(limit),
  });
  return request(`/api/email/submissions?${params.toString()}`);
}

export { CLOCK_SUPPORT_CATEGORY };
